export default "__VITE_ASSET__57083c83__"